"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableCard = void 0;
// packages
const react_1 = __importStar(require("react"));
// styles
const ExpandableCard_styles_1 = require("./ExpandableCard.styles");
const ExpanderContext = react_1.createContext({ expanded: false });
const ExpandableCardSummary = ({ children }) => {
    const _a = react_1.useContext(ExpanderContext), { badgeColor, badgeCount, collapsedIcon, hideCollapsedIcon, expanded, expandedIcon, hasBadge, icon, iconSize, isVisible = true, keepExpanded, onClick, summaryColor, summaryHeight, summaryStatus } = _a, restProps = __rest(_a, ["badgeColor", "badgeCount", "collapsedIcon", "hideCollapsedIcon", "expanded", "expandedIcon", "hasBadge", "icon", "iconSize", "isVisible", "keepExpanded", "onClick", "summaryColor", "summaryHeight", "summaryStatus"]);
    const height = summaryHeight || '56px';
    const CardIcon = () => {
        if (icon) {
            return react_1.default.createElement(react_1.default.Fragment, null, icon);
        }
        const getIcon = () => {
            if (expanded && expandedIcon) {
                return expandedIcon;
            }
            if (!expanded && collapsedIcon) {
                return collapsedIcon;
            }
            if (expanded) {
                return 'chevronUp';
            }
            return 'chevronDown';
        };
        return react_1.default.createElement(ExpandableCard_styles_1.StyledIcon, { icon: getIcon(), size: iconSize || '12' });
    };
    if (!isVisible) {
        return null;
    }
    const ShowHideCollapseIcon = () => {
        if (!keepExpanded) {
            if (expanded && hideCollapsedIcon) {
                return null;
            }
            else {
                return (react_1.default.createElement(ExpandableCard_styles_1.IconContainer, null,
                    react_1.default.createElement(CardIcon, null)));
            }
        }
        return null;
    };
    return (react_1.default.createElement(ExpandableCard_styles_1.SummarySection, Object.assign({ color: summaryColor, expanded: expanded, height: height, icon: icon, status: summaryStatus }, restProps),
        react_1.default.createElement(ExpandableCard_styles_1.StyledSummary, { onClick: onClick },
            react_1.default.createElement(ExpandableCard_styles_1.SummaryContent, null,
                hasBadge ? (react_1.default.createElement(ExpandableCard_styles_1.SummaryBadge, { badgeColor: badgeColor }, badgeCount)) : null,
                children),
            react_1.default.createElement(ShowHideCollapseIcon, null))));
};
const ExpandableCardDetails = ({ children }) => {
    const _a = react_1.useContext(ExpanderContext), { detailsColor, detailsHeight, detailsStatus, expanded, keepExpanded, onClick } = _a, restProps = __rest(_a, ["detailsColor", "detailsHeight", "detailsStatus", "expanded", "keepExpanded", "onClick"]);
    const isExpaned = keepExpanded || expanded;
    const height = isExpaned ? detailsHeight || '56px' : '0px';
    return (react_1.default.createElement(ExpandableCard_styles_1.DetailsSection, Object.assign({ expanded: isExpaned, height: height, color: detailsColor, status: detailsStatus }, restProps),
        react_1.default.createElement(ExpandableCard_styles_1.StyledDetails, { expanded: isExpaned },
            react_1.default.createElement("div", null, children))));
};
exports.ExpandableCard = (props) => (react_1.default.createElement(ExpanderContext.Provider, { value: props }, props.children));
exports.ExpandableCard.Summary = ExpandableCardSummary;
exports.ExpandableCard.Details = ExpandableCardDetails;
//# sourceMappingURL=ExpandableCard.js.map